import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBagIcon, Share2Icon, WalletIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

/** Tilted squircle tiles — deliberately different from the round badges above. */
const TILES = [{
  icon: ShoppingBagIcon,
  tile: 'bg-blue-600 text-white shadow-xl shadow-blue-600/30 -rotate-6',
  accent: 'bg-blue-600 text-white'
}, {
  icon: Share2Icon,
  tile: 'bg-blue-50 text-blue-600 ring-2 ring-blue-200 shadow-lg shadow-blue-600/10 rotate-3',
  accent: 'bg-blue-100 text-blue-700'
}, {
  icon: WalletIcon,
  tile: 'bg-slate-900 text-white shadow-xl shadow-slate-900/25 -rotate-3',
  accent: 'bg-slate-900 text-white'
}];
export function StepsSection() {
  const {
    t
  } = useLanguage();
  return <section id="how-it-works" className="w-full border-t border-slate-200 bg-slate-50" data-id="element-127" data-mp="27bag1wta4v0k">
      <div className="mx-auto w-full max-w-[1280px] px-5 py-20 sm:px-8 lg:py-28" data-id="element-128" data-mp="22c7dcj0rv0vr">
        <div className="mx-auto max-w-[720px] text-center" data-id="element-129" data-mp="2coavyf0w86a6">
          <h2 className="text-[clamp(2rem,4.2vw,3rem)] font-extrabold leading-tight tracking-[-0.03em] text-slate-900" data-id="element-130" data-mp="2cpudsa276pe2">
            {t.steps.title}
          </h2>
          <p className="mt-4 text-[17px] text-slate-600" data-id="element-131" data-mp="2mkvxurhm919s">{t.steps.subtitle}</p>
        </div>

        <ol className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-132" data-mp="2qo25o3kdn0id">
          {t.steps.items.map((step, i) => {
          const tile = TILES[i];
          const Icon = tile.icon;
          return <motion.li key={step.title} initial={{
            opacity: 0,
            y: 22
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.45,
            ease: 'easeOut',
            delay: i * 0.1
          }} className="relative rounded-3xl border border-slate-200 bg-white p-8 text-center shadow-sm md:text-left" data-id="element-133" data-mp="30jvp86wiju9n" data-mpi={i}>
                <div className="flex items-center justify-center gap-4 md:justify-start" data-id="element-134" data-mp="3j9lmd0nr0s4q">
                  <span className={`inline-flex h-[96px] w-[96px] items-center justify-center rounded-[28px] transition-transform duration-300 md:h-[78px] md:w-[78px] ${tile.tile}`} aria-hidden="true" data-id="element-135" data-mp="1j7c8h1xp05gi">
                    <Icon size={46} strokeWidth={1.8} className="md:hidden" data-id="element-136" data-mp="1o7zxxj69we8m" />
                    <Icon size={36} strokeWidth={1.8} className="hidden md:block" data-id="element-137" data-mp="22wwg4921n7my" />
                  </span>
                  <span className={`inline-flex h-9 w-9 items-center justify-center rounded-full text-[14px] font-extrabold ${tile.accent}`} data-id="element-138" data-mp="2byvwcz58i7ou">
                    {i + 1}
                  </span>
                </div>
                <h3 className="mt-6 text-[24px] font-extrabold tracking-tight text-slate-900 md:text-[22px]" data-id="element-139" data-mp="hmfipda3zr9y">
                  {step.title}
                </h3>
                <p className="mt-3 text-[16px] leading-relaxed text-slate-600" data-id="element-140" data-mp="2o9mwyopyoslo">
                  {step.text}
                </p>
              </motion.li>;
        })}
        </ol>
      </div>
    </section>;
}